module.exports = __webpack_public_path__ + "img/hengfeng_title.a8a50510.png";